import axios from "axios";
import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
//import { createUser } from "../services/createUser";
import { Link } from "react-router-dom";
import { environment } from "../../environment";
import Select from "react-select";
import { Country, State, City } from "country-state-city";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const AddLogisticManager = ({ history, match }) => {
  const [dap_firstName, setFirstName] = useState("");
  const [dap_lastName, setLastName] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_email, setEmail] = useState("");
  const [dap_password, setPassword] = useState("");
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_states, setDapState] = useState([]);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [dap_countries, setDapCountries] = useState("");
  const [poststate, setPostState] = useState("");
  const [zip, setZip] = useState("");
  const [postcity, setPostCity] = useState("");
  const [dap_groupEntityId, setGroupEntityId] = useState("");
  const [loading, setLoading] = useState(false);

  const [loader, setLoader] = useState(true);

  const [emailErrors, setEmailErrors] = useState({});
  const [passwordErrors, setPasswordErrors] = useState({});
  const [nameErrors, setNameErrors] = useState({});
  const [lastnameErrors, setLastNameErrors] = useState({});

  const c_id = localStorage.getItem("c_id");

  const dap_user_id = match.params.id;
  const [dap_tenantId, setTenantId] = useState("");
  let countries = [];
  let states = [];
  countries = Country.getAllCountries();
  states = State.getAllStates();
  const selectCountry = (e) => {
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
  };

  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
  };

  useEffect(() => {
    // let userDetails = "";
    // userDetails = localStorage.getItem("userDetails");
    // userDetails = JSON.parse(userDetails);
    // console.log("hyyy there", userDetails.data.tenantId.id);
    // setTenantId(userDetails.data.tenantId.id);
    // axios
    //   .get(
    //     environment.apiUrl + "entityGroups/CUSTOMER/" + dap_user_id + "/USER",
    //     // { dap_tenantId },
    //     {
    //       headers: {
    //         "X-Authorization": "Bearer " + localStorage.getItem("token"),
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     console.log("group entity", res.data[2].id.id);
    //     setGroupEntityId(res.data[2].id.id);
    //   })
    //   .catch((err) => {});
  }, []);

  const formValidation = () => {
    const emailErrors = {};
    const passwordErrors = {};
    const nameErrors = {};
    const lastnameErrors = {};
    let isValid = true;

    if (!dap_email) {
      emailErrors.noEmail = "* Email Id required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(dap_email)) {
      emailErrors.invalidEmail = "* Email address is invalid";
      isValid = false;
    }
    // if (!dap_password) {
    //   passwordErrors.noPassword = "* Password is required";
    //   isValid = false;
    // }
    if (!dap_firstName) {
      nameErrors.noName = "* First Name is required";
      isValid = false;
    } else if (dap_firstName.trim().length < 2) {
      nameErrors.shortName = "* Name is too short";
      isValid = false;
    } else if (dap_firstName.trim().length > 30) {
      nameErrors.shortName = "* Name is too long";
      isValid = false;
    }

    if (!dap_lastName) {
      lastnameErrors.noName = "* Last Name is required";
      isValid = false;
    } else if (dap_lastName.trim().length < 2) {
      lastnameErrors.shortName = "* Name is too short";
      isValid = false;
    } else if (dap_lastName.trim().length > 30) {
      lastnameErrors.shortName = "* Name is too long";
      isValid = false;
    }

    setEmailErrors(emailErrors);
    // setPasswordErrors(passwordErrors);
    setNameErrors(nameErrors);
    setLastNameErrors(lastnameErrors);
    return isValid;
  };

  const submitHandler = (e) => {
    let validform = formValidation();

    e.preventDefault();
    //setLoading(true);
    if (validform) {
      axios
        .post(
          //"user?sendActivationMail=true",
          environment.dap_url + "logisticManager/create",
          {
            email: dap_email,
            // password: dap_password,
            userFirstName: dap_firstName,
            userLastName: dap_lastName,
            phone: dap_phone,
            country: postcountry,
            state: poststate,
            city: postcity,
            address: dap_address,
            userType: "LOGISTIC_MANAGER",
          }
        )
        .then((res) => {
          console.log(res.data);
          if (res.data.error) {
            MySwal.fire({
              title: <p>Given Mail id already exist</p>,
              type: "success",
            });
          } else {
            MySwal.fire({
              title: <p>Logistic Manager has been successfully created!</p>,
              type: "success",
            });
            history.push("/logisticmanagers");
          }
        })
        .catch((err) => {
          console.log(err);
          MySwal.fire({
            title: <p>{err?.response?.data?.message}</p>,
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <Link to={`/logisticmanagers`} className="btn btn-light my-3">
          Go Back
        </Link>

        <div className="row">
          <div className="col-lg-3"></div>
          <div className="col-md-6 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h1 className="text-center">ADD LOGISTIC MANAGER</h1>
                <Form onSubmit={submitHandler}>
                  <Form.Group controlId="title">
                    <Form.Label>* Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      value={dap_email}
                      onChange={(e) => setEmail(e.target.value)}
                    ></Form.Control>
                    <div>
                      {Object.keys(emailErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>{emailErrors[key]}</div>
                        );
                      })}
                    </div>
                  </Form.Group>
                  {/* <Form.Group controlId="title">
                    <Form.Label>* Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter Email"
                      value={dap_password}
                      onChange={(e) => setPassword(e.target.value)}
                    ></Form.Control>
                    <div>
                      {Object.keys(passwordErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>
                            {passwordErrors[key]}
                          </div>
                        );
                      })}
                    </div>
                  </Form.Group> */}

                  <Form.Group controlId="title">
                    <Form.Label>*First Name</Form.Label>
                    <Form.Control
                      type="userFirstName"
                      placeholder="Enter First Name"
                      value={dap_firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    ></Form.Control>
                    <div>
                      {Object.keys(nameErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>{nameErrors[key]}</div>
                        );
                      })}
                    </div>
                  </Form.Group>

                  <Form.Group controlId="userLastName">
                    <Form.Label>*Last Name</Form.Label>
                    <Form.Control
                      type="userLastName"
                      placeholder="Enter Last Name"
                      value={dap_lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    ></Form.Control>
                    <div>
                      {Object.keys(lastnameErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>
                            {lastnameErrors[key]}
                          </div>
                        );
                      })}
                    </div>
                  </Form.Group>

                  <Form.Group controlId="phone">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="phone"
                      placeholder="Add Phone"
                      value={dap_phone}
                      onChange={(e) => setPhone(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                  <div className="row">
                    <div className="col-4">
                      <Form.Group controlId="name">
                        <Form.Label>Country</Form.Label>
                        <Select
                          options={countries.map((element) => ({
                            id: element.isoCode,
                            value: element.name,
                            label: element.name,
                          }))}
                          onChange={(e) => selectCountry(e)}
                          // defaultValue={dap_deviceList[0].name}
                          // defaultValue="hi there"
                          placeholder="Country"
                        />
                      </Form.Group>
                    </div>
                    <div className="col-4">
                      <Form.Group controlId="name">
                        <Form.Label>State</Form.Label>
                        <Select
                          options={dap_states.map((element) => ({
                            id: element.isoCode,
                            value: element.name,
                            label: element.name,
                          }))}
                          onChange={(e) => selectRegion(e)}
                          // defaultValue={dap_deviceList[0].name}
                          defaultValue="hi there"
                          placeholder="State"
                        />
                      </Form.Group>
                    </div>
                    <div className="col-4">
                      <Form.Group controlId="name">
                        <Form.Label>City</Form.Label>
                        <Select
                          options={dap_city.map((element) => ({
                            id: element.isoCode,
                            value: element.name,
                            label: element.name,
                          }))}
                          onChange={(e) => selectCity(e)}
                          // defaultValue={dap_deviceList[0].name}
                          defaultValue="hi there"
                          placeholder="City"
                        />
                      </Form.Group>
                    </div>
                  </div>

                  <Form.Group controlId="address">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="address"
                      placeholder="Enter Address"
                      value={dap_address}
                      onChange={(e) => setAddress(e.target.value)}
                    ></Form.Control>
                  </Form.Group>

                  <div className="mt-3">
                    <Button
                      type="submit"
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      disabled={loading}
                    >
                      ADD LOGISTIC MANAGER
                      {loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      {loading && <span></span>}
                      {!loading && <span></span>}
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          <div className="col-lg-3"></div>
        </div>
      </div>
    </>
  );
};

export default AddLogisticManager;
